/* tslint:disable */
/* eslint-disable */
/**
 * Scania Configurator
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime'
/**
 * Legacy response wrapper structure to allow matching the original
 * configurator web API.
 *
 * TODO: This should be removed after the .Net Core and ScdsClient
 * migration has been completed.
 * @export
 * @interface LogoutResponseWrapper
 */
export interface LogoutResponseWrapper {
  /**
   *
   * @type {boolean}
   * @memberof LogoutResponseWrapper
   */
  logout?: boolean | null
  /**
   *
   * @type {string}
   * @memberof LogoutResponseWrapper
   */
  error?: string | null
}

/**
 * Check if a given object implements the LogoutResponseWrapper interface.
 */
export function instanceOfLogoutResponseWrapper(value: object): boolean {
  let isInstance = true

  return isInstance
}

export function LogoutResponseWrapperFromJSON(
  json: any,
): LogoutResponseWrapper {
  return LogoutResponseWrapperFromJSONTyped(json, false)
}

export function LogoutResponseWrapperFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): LogoutResponseWrapper {
  if (json === undefined || json === null) {
    return json
  }
  return {
    logout: !exists(json, 'logout') ? undefined : json['logout'],
    error: !exists(json, 'error') ? undefined : json['error'],
  }
}

export function LogoutResponseWrapperToJSON(
  value?: LogoutResponseWrapper | null,
): any {
  if (value === undefined) {
    return undefined
  }
  if (value === null) {
    return null
  }
  return {
    logout: value.logout,
    error: value.error,
  }
}
